<template>
    <div>
        <SubHeader :text="$t('h.gaa')" :imgUrl="imgUrl" />
        <div class="global-img">
            <img :src="imgUrl1" alt="image" />
        </div>
        <Content0 />
    </div>
</template>
<script>
import SubHeader from "@/components/SubHeader.vue";
import Content0 from "./Content0.vue";
import initAnimation from "../animation";
export default {
    data() {
        return {
            imgUrl: require("@/assets/images/sub_page_banner_5.jpg"),
            imgUrl1: require("@/assets/images/global_app_access_img_1.jpg"),
        };
    },
    mounted() {
        setTimeout(initAnimation, 0);
    },
    components: {
        SubHeader,
        Content0,
    },
};
</script>
<style scoped>
.global-img {
    width: 1180px;
    margin: 149px auto 88px;
}
.global-img > img {
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/Pages/GlobalAppAccess/GlobalAppAccess.vue